import React from 'react';

/**
 * Компонент для отображения статуса экспорта данных
 */
const ExportStatusIndicator = ({ exportStatus }) => {
  const { inProgress, type, progress, fileName } = exportStatus || {};
  
  if (!inProgress) return null;
  
  const getTypeLabel = () => {
    switch (type) {
      case 'omsu': return 'ОМСУ';
      case 'iogv': return 'ИОГВ';
      case 'excel-omsu': return 'Excel ОМСУ';
      case 'excel-iogv': return 'Excel ИОГВ';
      case 'all': return 'всех материалов';
      default: return 'данных';
    }
  };
  
  const getStatusMessage = () => {
    if (progress < 20) return 'Подготовка данных...';
    if (progress < 50) return 'Генерация SVG...';
    if (progress < 75) return 'Конвертация в PNG...';
    if (progress < 100) return 'Завершение экспорта...';
    return 'Экспорт завершен';
  };
  
  const getBgColor = () => {
    if (progress >= 100) return 'bg-green-100 border-green-300';
    return 'bg-blue-50 border-blue-200';
  };
  
  const getTextColor = () => {
    if (progress >= 100) return 'text-green-700';
    return 'text-blue-700';
  };
  
  const getIconColor = () => {
    if (progress >= 100) return '#047857';
    return '#0284c7';
  };
  
  return (
    <div className={`fixed bottom-4 right-4 p-3 rounded-lg border shadow-lg z-50 ${getBgColor()} max-w-sm transition-all duration-300`}>
      <div className="flex items-start">
        {progress < 100 ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={getIconColor()} strokeWidth="2" className="mr-3 animate-spin">
            <circle cx="12" cy="12" r="10" strokeOpacity="0.25" />
            <path d="M12 2C6.5 2 2 6.5 2 12" />
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={getIconColor()} strokeWidth="2" className="mr-3">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        )}
        
        <div className="flex-1">
          <p className={`font-medium ${getTextColor()} text-sm`}>
            {progress >= 100 ? 'Экспорт завершен' : 'Экспорт в процессе'}
          </p>
          <p className="text-gray-600 text-xs mt-1">
            {fileName ? `${fileName} (${getTypeLabel()})` : `Экспорт ${getTypeLabel()}`}
          </p>
          
          <div className="w-full bg-gray-200 rounded-full h-1.5 my-2">
            <div 
              className="h-1.5 rounded-full bg-blue-600 transition-all duration-300" 
              style={{ width: `${Math.min(100, progress)}%` }}
            ></div>
          </div>
          
          <p className="text-xs text-gray-500">{getStatusMessage()}</p>
        </div>
      </div>
    </div>
  );
};

export default ExportStatusIndicator; 